export const errorBoundaryContent = {
  errorMessage: 'Whoops, something went wrong.',
  unknownError: 'An unknown error occurred.',
  refreshPage: 'Please refresh the page or try to launch app again.',
  btnText: 'Refresh',
  getInTouchMessage: 'If issue persists, reachout to team on',
};
